class SubjectSelectionShared {

    static subjectSelection = null
    static setSubjectSelection(value) {
        this.subjectSelection = value
    }
    
    static getSubjectSelection() {
        return this.subjectSelection
    }

}

export default SubjectSelectionShared;